import React from 'react'

import {Buttons, ButtonPrimary} from '../../ui-kit/Button'
import Animate from '../../ui-kit/Animate'

import {ButtonBlock, TextBlock, SubHeading, TextCenter, Heading, Paragraph, Item, Content} from '../../styles'

var Text7 = ({onNext}) => {

  return (
    <Content>
      <TextBlock>
        <Animate duration=".8s" delay=".3s">
          <Heading>
            Primeiro
          </Heading>
        </Animate>
    
        <Animate duration=".8s" delay="1s">
          <SubHeading>
            Gostaríamos de ter uma ideia de:
            <br/>
            <i>"Que tipo de corpo você gostaria de ter?"</i>
          </SubHeading>
        </Animate>

        <Animate duration=".8s" delay="2s">
          <TextCenter>
            <img src="https://i.imgur.com/m2v4ZkH.gif" width="110" />
            <br/><br/>
          </TextCenter>
        </Animate>

        <Animate duration=".8s" delay="3s">
          <Paragraph>
            <Animate duration=".8s" delay="3s">
              <Item>- Vamos te mostrar algumas imagens</Item>
            </Animate>
            <Animate duration=".8s" delay="3.5s">
              <Item>- E no final você pode nos enviar outras, ou links pro instagram de pessoas que te inspiram</Item>
            </Animate>
          </Paragraph>
        </Animate>
      </TextBlock>

      <Animate duration=".3s" delay="4.5s">
        <ButtonBlock>
          <Buttons>
            <ButtonPrimary onClick={onNext}>
              Próximo
            </ButtonPrimary>
          </Buttons>
        </ButtonBlock>
      </Animate>
    </Content>
  )

}

export default Text7